<ph-select [items]="selectItems"
           [value]="selectedKey"
           [placeholder]="placeholder || (statesOnly ? 'State' : '-- Select --')"
           [size]="size"
           [disabled]="disabled || readonly || boundControl?.disabled"
           aria-label="select state"
           (ph-change)="onRegionSelected($event.detail)"></ph-select>
